import { DatePicker } from 'antd'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { InfoCircleOutlined } from '@ant-design/icons'
import moment from 'moment'

import './RangePicker.scss'

const { RangePicker } = DatePicker
const dateFormat = 'DD/MM/YYYY'

const RangePickerC = ({ onChange, note, value, syncToUrl = false }) => {
  const { t } = useTranslation()
  const history = useHistory()
  const fromDate = new URLSearchParams(history.location.search).get('from_date')
  const toDate = new URLSearchParams(history.location.search).get('to_date')
  const fromDateObj = fromDate ? moment(fromDate, 'DD-MM-YYYY') : null
  const toDateObj = toDate ? moment(toDate, 'DD-MM-YYYY') : null

  return (
    <div>
      <RangePicker
        id='date'
        name='date'
        value={value ?? [fromDateObj, toDateObj]}
        format={dateFormat}
        placeholder={[t('Start date'), t('End date')]}
        onChange={(dates, rangeString) => {
          if (typeof onChange === 'function') {
            onChange(dates, rangeString)
          }

          if (syncToUrl || typeof onChange !== 'function') {
            // Recreate search params to ensure we're working with latest location
            const searchParams = new URLSearchParams(history.location.search)

            // dates may be null when user clears selection
            if (rangeString && rangeString[0] && rangeString[1]) {
              const from_date = rangeString[0].split('/').join('-')
              const to_date = rangeString[1].split('/').join('-')

              searchParams.set('from_date', from_date)
              searchParams.set('to_date', to_date)
              searchParams.set('page', 1)

              // Defer navigation slightly to avoid interfering with internal focus/DOM handlers
              setTimeout(() => {
                history.push({
                  pathname: history.location.pathname,
                  search: searchParams.toString(),
                })
              }, 0)
            } else if (!rangeString || (!rangeString[0] && !rangeString[1])) {
              searchParams.delete('from_date')
              searchParams.delete('to_date')
              searchParams.set('page', 1)

              setTimeout(() => {
                history.push({
                  pathname: history.location.pathname,
                  search: searchParams.toString(),
                })
              }, 0)
            }
          }
        }}
      />
      {note && (
        <small className='text-success'>
          <InfoCircleOutlined className='me-2' />
          {note}
        </small>
      )}
    </div>
  )
}

export default RangePickerC
